import { ROUTES } from "modules/home/enums/routes.enum"

/**
 * Checks if given path exist in defined app routes
 */
export const isValidRoute = (path: string) => {
    return Object.values(ROUTES).includes(path as ROUTES);
}
